import { render, staticRenderFns } from "./BulkAttendance.vue?vue&type=template&id=5d8fb673&scoped=true&"
import script from "./BulkAttendance.vue?vue&type=script&lang=js&"
export * from "./BulkAttendance.vue?vue&type=script&lang=js&"
import style0 from "./BulkAttendance.vue?vue&type=style&index=0&id=5d8fb673&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8fb673",
  null
  
)

export default component.exports